module.exports = __webpack_public_path__ + "media/images/emblems/Corcelles-le-Jorat-coat_of_arms-c49f4a4c9a3c7491a9946978e13b1c54.svg";